var $105d5a718d0c1e58$exports = {};
$105d5a718d0c1e58$exports = {
    "info": `Informacija`,
    "negative": `Klaida`,
    "positive": `S\u{117}kmingai`
};


export {$105d5a718d0c1e58$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
